import React from 'react'

import { withTranslation } from 'react-i18next'
import { Typography, Paper, Button, Divider, IconButton } from '@material-ui/core'
import {
    ArrowBackIos as ArrowBackIosIcon,
    ArrowForwardIos as ArrowForwardIosIcon,
    Cancel as CancelIcon,
} from '@material-ui/icons'

import { shortMonthNames } from '../DateTools/MonthsNames'

const MONTH_ROWS = [
    [1, 2, 3],
    [4, 5, 6],
    [7, 8, 9],
    [10, 11, 12],
]

/**
 * The month grid every period picker shares. Fully controlled: the browsed year
 * and the selected period both live in the parent, so there is no second copy
 * of the value to drift out of sync.
 *
 * Props:
 *   year          year whose months are shown
 *   bounds        PeriodBounds strategy; decides what is selectable
 *   onChangeYear  (year) => void, called by the year arrows
 *   onSelect      (year, month) => void
 *   onClear       clear handler, or null for no clear affordance
 */
const PeriodGrid = (props) => {
    const { year, bounds, onChangeYear, onSelect, onClear, t } = props
    const months = shortMonthNames(t)

    return (
        <Paper style={{ position: 'relative' }}>
            {/* <- YYYY -> (x) */}
            <div>
                <Typography style={{ textAlign: 'center' }}>
                    {onClear ?
                        <CancelIcon fontSize='small' style={{ position: 'absolute', right: 3, top: 3, cursor: 'pointer' }} onClick={onClear} />
                        : null}
                    <IconButton disabled={!bounds.reachesYear(year - 1)} onClick={() => onChangeYear(year - 1)}>
                        <ArrowBackIosIcon fontSize='small' />
                    </IconButton>
                    {year}
                    <IconButton disabled={!bounds.reachesYear(year + 1)} onClick={() => onChangeYear(year + 1)}>
                        <ArrowForwardIosIcon fontSize='small' />
                    </IconButton>
                </Typography>
            </div>
            <Divider />
            {MONTH_ROWS.map(row => (
                <div key={row[0]}>
                    {row.map(month => (
                        <Button
                            key={month}
                            disabled={!bounds.includes({ year, month })}
                            onClick={() => onSelect(year, month)}
                            color='primary'
                        >
                            {months[month - 1]}
                        </Button>
                    ))}
                </div>
            ))}
        </Paper>
    )
}

export default withTranslation()(PeriodGrid)
